import { type ServiceParams, unwrapJson } from "../client";
import type { UserListFilters, UserListResponse } from "./types";

/**
 * Users service — wraps the tenant-admin user-management endpoints
 * under ``/v1/admin/users``. Read paths surface the standard
 * pagination envelope; mutation paths are intentionally NOT wired
 * in FE-4 (role change / soft-delete / invite-by-email belong to
 * Phase D — the FE-4 surface is read-only + invite-via-signup-key).
 */
const Users = ({ url, config }: ServiceParams) => {
  const base = `${url}/v1/admin/users`;

  const buildQuery = (filters?: Record<string, unknown>) => {
    const params = new URLSearchParams();
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      }
    }
    const qs = params.toString();
    return qs ? `?${qs}` : "";
  };

  return {
    async list(
      filters: UserListFilters = {}
    ): Promise<UserListResponse> {
      const response = await fetch(
        `${base}${buildQuery(filters as Record<string, unknown>)}`,
        { method: "GET", headers: config() }
      );
      return unwrapJson<UserListResponse>(response);
    },
  };
};

export default Users;
